export default {
  props: {
    _groupCode: [Array, String],
    contentData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  methods: {
    // 加入接口意向单
    // addOrderList() {
    //   let _id = '';
    //   if (this.contentData.list.length > 0){
    //     _id = this.contentData.list.map(item => item._id).toString();
    //   }
    //   this.$emit('addOrderList', {
    //     product_code: _id,
    //     product_type: 3,
    //   });
    // },
  }
};